import { ModuleWithProviders, NgModule } from "@angular/core";
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';

import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions, MatFormFieldModule } from '@angular/material/form-field';

const MODULES = [
    MatIconModule,
    MatDialogModule,
    MatButtonModule,
    MatRadioModule,
    MatInputModule,
    MatSnackBarModule,
    MatFormFieldModule,
    MatTooltipModule
]

@NgModule({
    imports: MODULES,
    exports: MODULES
})
export class MaterialModule {
    static forRoot(): ModuleWithProviders<MaterialModule> {
        return <ModuleWithProviders<MaterialModule>>{
            ngModule: MaterialModule,
            providers: [
                { 
                    provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, 
                    useValue: <MatFormFieldDefaultOptions>{
                        appearance: 'outline',
                        floatLabel: 'always'
                    }
                }
            ]
        }
    }
}